import React from "react";
import { FormattedMessage } from "react-intl";
import { AHButton, AHText, Box } from "arkh";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { useLogout } from "../../OS/Login/useLogin";

export const ErrorFallbackWithLogout = (props: {
  resetErrorBoundary: () => void;
}) => {
  const intl_tokens = useIntlTokens();
  const logout = useLogout();
  return (
    <Box
      style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
      space="large"
    >
      <AHText spaceBottom="medium" type="title-small">
        <FormattedMessage
          defaultMessage="An error occured"
          description="ErrorBoundary title"
        />
      </AHText>
      <AHText
        type="body"
        spaceBottom="medium"
        style={{ maxWidth: 450, textAlign: "center" }}
      >
        <FormattedMessage
          defaultMessage="It seems to be a problem with the internet connection. Please check your internet connection."
          description="ErrorBoundary description"
        />
      </AHText>
      <AHButton
        loading={false}
        onPress={props.resetErrorBoundary}
        themeType="primary"
        title="Försök igen"
      />
      <Box spaceTop="xlarge" />
      <AHButton
        onPress={logout}
        title={intl_tokens.LogOut}
        themeType="negative"
      />
    </Box>
  );
};
